<div class="overlay-inner-wrapper">
  @if (!isInspektion()) {
    <header class="header-2">
      <div class="branding">
        <span class="title">{{ 'Grundinstandsetzung verwalten' | mrTranslate }} • {{ bezeichnung() }}</span>
      </div>
      <div class="header-actions">
        <a href="javascript:void(0);" class="nav-link nav-icon" (click)="close()">
          <cds-icon shape="times"/>
        </a>
      </div>
    </header>
  }
  <div
    id="bauwerksWrapper"
    class="w-100-p padding-10-lr padding-12-b scroll-y"
    [ngClass]="isInspektion() ? 'h-100' : 'h-60'">
    <div class="clr-row nxm clr-justify-content-end">
      <div class="clr-col-auto margin-12-tb">
        <div class="btn-group btn-primary btn-icon">
          <button class="btn btn-icon btn-success" [title]="'Neu' | mrTranslate" (click)="addGI()">
            <cds-icon shape="file" />
          </button>
          <button
            class="btn btn-icon btn-danger"
            [title]="'Löschen' | mrTranslate"
            [disabled]="!selectedGI()"
            (click)="deleteGI()">
            <cds-icon shape="times" />
          </button>

          <button
            type="submit"
            form="grundinstand-form"
            class="btn btn-icon margin-12-l"
            [clrLoading]="saveState()"
            [title]="'Speichern' | mrTranslate">
            <cds-icon shape="floppy" />
          </button>
        </div>
      </div>
    </div>
    <form
      id="grundinstand-form"
      [formGroup]="formGITop"
      (ngSubmit)="saveIfValid()"
      [clrLabelSize]="12"
      clrForm
      clrLayout="vertical"
      class="width100 padding-12-lr margin--35-t">
      @if (formGITop.errors?.['not-in-Direction']; as err) {
        <div class="clr-row nxm clr-col-12 clr-col-sm-10 clr-col-md-8 clr-col-lg-6">
          <clr-alert class="w-100-p" clrAlertType="danger" [clrAlertClosable]="false">
            <clr-alert-item>
              <span class="alert-text">
                {{
                  'Die Startmeter kann nicht ' + (err.upwards ? 'größer' : 'kleiner') + ' als der Endmeter sein' | mrTranslate
                }}
              </span>
            </clr-alert-item>
          </clr-alert>
        </div>
      }

      <div class="clr-row nxm">
        @if (typ_Line_Point() | objtype: 'line') {
          <div class="clr-col-md-2 clr-col-sm-4 clr-col-6" [class.clr-order-2]="drehung.isOn">
            <clr-number-input-container>
              <label for="von" class="clr-required-mark">
                {{ 'von' | mrTranslate }}
                <div
                  class="btn-group btn-sm btn-icon btn-outline"
                  style="margin-left: 10px; margin-top: -7px; float: inline-end">
                  <button
                    class="btn"
                    type="button"
                    [title]="'Geopos orten' | mrTranslate"
                    tabindex="-1"
                    (click)="findPositionAndAutofill('von')"
                    [clrLoading]="geoState()"
                    [disabled]="formGITop.disabled">
                    <cds-icon shape="map-marker" />
                  </button>
                </div>
              </label>

              <input
                type="number"
                clrNumberInput
                formControlName="von"
                [value]="formGITop.controls.von.value | drehung: drehung.summe"
                (change)="formGITop.controls.von.setValue(drehungPipe.back($event.target.value, drehung.summe))"
                [step]="0.1"
                [attr.placeholder]="minMeter()" />
              <clr-control-error *clrIfError="'required'">
                {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
              </clr-control-error>
              @if (formGITop.controls.von.errors?.min; as err) {
                <clr-control-error>
                  {{ 'Der Wert ist ' + (!drehung.isOn ? 'kleiner' : 'größer') + ' als' | mrTranslate }}
                  {{ err.min | drehung: drehung.summe }}
                </clr-control-error>
              }
              @if (formGITop.controls.von.errors?.max; as err) {
                <clr-control-error>
                  {{ 'Der Wert ist ' + (!drehung.isOn ? 'größer' : 'kleiner') + ' als' | mrTranslate }}
                  {{ err.max | drehung: drehung.summe }}
                </clr-control-error>
              }
            </clr-number-input-container>
          </div>
          <div class="clr-col-md-2 clr-col-sm-4 clr-col-6" [class.clr-order-2]="drehung.isOn">
            <clr-number-input-container>
              <label for="bis" class="clr-required-mark">
                {{ 'bis' | mrTranslate }}
                <div
                  class="btn-group btn-sm btn-icon btn-outline"
                  style="margin-left: 10px; margin-top: -7px; float: inline-end">
                  <button
                    class="btn"
                    type="button"
                    [title]="'Geopos orten' | mrTranslate"
                    tabindex="-1"
                    (click)="findPositionAndAutofill('bis')"
                    [clrLoading]="geoState()"
                    [disabled]="formGITop.disabled">
                    <cds-icon shape="map-marker" />
                  </button>
                </div>
              </label>

              <input
                type="number"
                clrNumberInput
                formControlName="bis"
                [value]="formGITop.controls.bis.value | drehung: drehung.summe"
                (change)="formGITop.controls.bis.setValue(drehungPipe.back($event.target.value, drehung.summe))"
                [step]="0.1"
                [attr.placeholder]="minMeter()" />
              <clr-control-error *clrIfError="'required'">
                {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
              </clr-control-error>
              @if (formGITop.controls.bis.errors?.min; as err) {
                <clr-control-error>
                  {{ 'Der Wert ist ' + (!drehung.isOn ? 'kleiner' : 'größer') + ' als' | mrTranslate }}
                  {{ err.min | drehung: drehung.summe }}
                </clr-control-error>
              }
              @if (formGITop.controls.bis.errors?.max; as err) {
                <clr-control-error>
                  {{ 'Der Wert ist ' + (!drehung.isOn ? 'größer' : 'kleiner') + ' als' | mrTranslate }}
                  {{ err.max | drehung: drehung.summe }}
                </clr-control-error>
              }
            </clr-number-input-container>
          </div>
        }
        <div class="clr-col-md-2 clr-col-sm-4 clr-col-6 clr-order-3">
          <clr-control-container>
            <label class="clr-required-mark">{{ 'Grundinstandsetzung' | mrTranslate }}</label>
            <app-datalist-input [datalist]="artListe()" placeholder="" formControlName="Grundinstandsetzung" />
            <clr-control-error *clrIfError="'required'">
              {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
            </clr-control-error>
          </clr-control-container>
        </div>
      </div>
    </form>
    @if (table().columns.length) {
      <clr-datagrid
        class="datagrid-compact dg-overflow-fix"
        style="max-height: calc(100svh - 400px)"
        [clrDgItemsIdentityFn]="row => row?.id"
        [clrDgRowSelection]="true"
        [clrDgSelectionType]="'single'"
        [clrDgSelected]="[selectedGI()]"
        (clrDgSelectedChange)="selectedChange($event)">
        @if (typ_Line_Point() | objtype: 'line') {
          <clr-dg-column
            [clrDgField]="!drehung.isOn ? 'von' : 'bis'"
            [clrDgSortOrder]="direction() * (drehung.isOn ? -1 : 1)">
            {{ 'Startmeter' | titlecase | mrTranslate }}
          </clr-dg-column>
          <clr-dg-column [clrDgField]="!drehung.isOn ? 'bis' : 'von'">
            {{ 'Endmeter' | titlecase | mrTranslate }}
          </clr-dg-column>
        }
        @for (column of table().columns | array: 'filter' : exceptStartEnd; track column.id) {
          <clr-dg-column [clrDgField]="column.id">
            <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['id', 'ostammid', 'bild'] }">
              {{ column.id | titlecase | mrTranslate }}
            </ng-container>
          </clr-dg-column>
        }

        <clr-dg-row *clrDgItems="let row of table().rows" [clrDgItem]="row">
          @if (typ_Line_Point() | objtype: 'line') {
            <clr-dg-cell class="name-cell">
              {{ row[!drehung.isOn ? 'von' : 'bis'] | drehung: drehung.summe | tablePrettyPrint }}
            </clr-dg-cell>
          }
          @if (typ_Line_Point() | objtype: 'line') {
            <clr-dg-cell class="name-cell">
              {{ row[!drehung.isOn ? 'bis' : 'von'] | drehung: drehung.summe | tablePrettyPrint }}
            </clr-dg-cell>
          }
          @for (cell of table().columns | array: 'filter' : exceptStartEnd; track cell.id) {
            <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
          }
        </clr-dg-row>
        <clr-dg-footer>{{ table().rows?.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
      </clr-datagrid>
    }
  </div>
</div>
